module.exports = __webpack_public_path__ + "img/fa-brands-400.5c2d83d4.svg";